export function SectionHead({ title, eyebrow, action, sub }: { title: string; eyebrow?: string; action?: React.ReactNode; sub?: string }) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        {eyebrow && <p className="kicker">{eyebrow}</p>}
        <h2 className="h2 mt-1">{title}</h2>
        {sub && <p className="body-muted mt-2 max-w-[62ch]">{sub}</p>}
      </div>
      {action}
    </div>
  );
}
